(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-media-showcase"] && !Shopify.designMode) return;
  try {
    
  class BrandMediaShowcase extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.stage = this.querySelector('.brand-showcase__stage');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.addEventListener('shopify:block:select', (event) => {
        const selectedTab = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (selectedTab) this.activate(Number(selectedTab.dataset.index), true);
      });

      this.syncVideos();
    }

    activate(index, moveFocus = false) {
      if (!this.tabs[index] || !this.panels[index]) return;

      const update = () => {
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        this.syncVideos();
        if (moveFocus) this.tabs[index].focus({ preventScroll: true });
        this.tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      };

      if (document.startViewTransition && this.stage) {
        this.stage.style.viewTransitionName = `brand-showcase-${this.dataset.sectionId}`;
        document.startViewTransition(update);
      } else {
        update();
      }
    }

    onKeydown(event, index) {
      let nextIndex = index;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === index) return;
      event.preventDefault();
      this.activate(nextIndex, true);
    }

    syncVideos() {
      const shouldAutoplay = this.dataset.autoplay === 'true';
      this.panels.forEach((panel) => {
        panel.querySelectorAll('video').forEach((video) => {
          if (!panel.hidden && shouldAutoplay) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }
  }

  if (!customElements.get('brand-media-showcase')) {
    customElements.define('brand-media-showcase', BrandMediaShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
